import { notEmpty } from '@ezchops/helpers';
import { range } from 'lodash';
/**
 * @deprecated use sequencerConfig
 * @param trackSet
 * @param tempo
 */
export function selectTrack(trackSet, tempo) {
    return trackSet.tracks.find((track) => track.tempo == tempo);
}
export function generateTrackSheet(trackSet, tempo, segment, tickNote) {
    const track = selectTrack(trackSet, tempo);
    if (track == null) {
        throw new Error(`No track found for tempo ${tempo}`);
    }
    const { leadIn, leadOut } = trackSet;
    const { duration, offset } = track;
    const signature = segment.signature;
    const measures = secondsToMeasures(tempo, duration, signature, leadIn, leadOut);
    const period = segment.measures.length;
    const repeats = Math.floor((measures - leadIn - leadOut) / period) - 1;
    const durationInMeasures = (repeats + 1) * period + leadIn + leadOut;
    const remainder = Math.max(Math.ceil(measures - durationInMeasures), 0);
    return {
        segments: [
            generateLeadInSegment(signature, leadIn),
            { ...segment, repeats },
            generateLeadOutSegment(signature, leadOut + remainder + 1, tickNote)
        ].filter(notEmpty)
    };
}
function secondsToMeasures(tempo, duration, signature, leadIn, leadOut) {
    const notesPerSecond = tempo / (60 * signature.denominator);
    const measuresPerNote = signature.numerator / signature.denominator;
    const durationInNotes = duration * notesPerSecond;
    return durationInNotes * measuresPerNote;
}
export function generateLeadInSegment(signature, measures) {
    if (measures == 0) {
        return null;
    }
    return {
        signature,
        measures: range(0, measures).map(() => ({
            notes: [
                { duration: [signature.numerator, signature.denominator], notes: [] }
            ],
        })),
        repeats: 0
    };
}
export function generateLeadOutSegment(signature, measures, tickNote) {
    if (measures == 0) {
        return null;
    }
    return {
        signature,
        measures: range(0, measures).map(() => ({
            notes: [
                { duration: [1, tickNote], notes: [{}] }
            ],
        })),
        repeats: 0
    };
}
function generateSegmentMetronome(agg, segment) {
    const last = agg.at(-1);
    const repeats = segment.measures.length * (segment.repeats ?? 1);
    if (last != null && last.signature == segment.signature) {
        const finished = agg.slice(0, -1);
        return [
            ...finished,
            { ...last, repeats: (last.repeats ?? 1) + repeats }
        ];
    }
    return [
        ...agg,
        { ...segment, repeats, measures: [metronomeMeasure(segment.signature)] }
    ];
}
function metronomeMeasure(signature) {
    const { numerator, denominator } = signature;
    const notes = range(numerator).map((beat) => ({
        duration: [1, denominator],
        notes: beat == 0 ? [{ pitch: 75, dynamics: 'accent' }] : [{ pitch: 76 }]
    }));
    return { notes };
}
//# sourceMappingURL=generateTrackSheet.js.map